import { Fragment, useContext } from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Typography, TableFooter, Button, List, ListItem, ListItemSecondaryAction, IconButton, ListItemText, Grid } from '@mui/material';
import { addOrdersContext } from './AddOrdersContext';
import Moment from 'react-moment';
import { FaPlus } from 'react-icons/fa';
import { SearchType } from 'helpers/Enums';
import { appUserContext } from 'helpers/services';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import React from 'react';


let OrderResults = () => {
    let { formatMessage } = useIntl();

    let { isMobile } = useContext(appUserContext);
    let service = useContext(addOrdersContext);


    return <>
        {isMobile === false &&
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell padding="checkbox"></TableCell>
                        <TableCell>{formatMessage({ id: LocalizationIds.Order })}</TableCell>
                        <TableCell>{formatMessage({ id: LocalizationIds.Customer })}</TableCell>
                        <TableCell>{formatMessage({ id: LocalizationIds.Quote })}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.orders.map(order =>
                        <TableRow hover key={order.orderId}>
                            <TableCell padding="checkbox">
                                <Button
                                    size="small"
                                    onClick={(e) => service.onSelect({
                                        type: SearchType.Orders,
                                        orderId: order.orderId,
                                        orderNumber: order.orderNumber,
                                        orderDate: order.orderDate,
                                        orderTitle: order.quotes[0]?.title ?? "",
                                        orderType: order.orderType,
                                        articleDescription: '',
                                        articleId: '',
                                        articleModel: '',
                                        articleVersion: '',
                                        workOrderId: 0,
                                        workOrderNumber: ''
                                    })}
                                >
                                    <FaPlus />
                                </Button>
                            </TableCell>
                            <TableCell>
                                <b>{order.orderType}{order.orderNumber}</b>
                                <Typography variant="subtitle2">
                                    <Moment date={order.orderDate} format="LL" />
                                </Typography>
                                <Typography variant="subtitle2">{order.orderStatus}</Typography>
                            </TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap' }}>
                                <Typography>{order.customerName}</Typography>
                                <Typography variant="subtitle2">{order.customerCountry}</Typography>
                            </TableCell>
                            <TableCell>
                                {order.quotes &&
                                    order.quotes.map(quote =>
                                        <Fragment key={quote.quoteId}>
                                            <Typography>{formatMessage({ id: LocalizationIds.Quote })}&nbsp;{quote.quoteNumber}&nbsp;{formatMessage({ id: LocalizationIds.Rev })}&nbsp;{quote.quoteRevision}&nbsp;&middot;&nbsp;{quote.title}</Typography>
                                        </Fragment>
                                    )}
                                {order.layoutNumber?.trim() !== '' &&
                                    <>{formatMessage({ id: LocalizationIds.Layout })}:&nbsp;{order.layoutNumber?.trim()}</>
                                }
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {service.orders.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={4}><i>{formatMessage({ id: LocalizationIds.NoOrdersFound })}</i></TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
        }
        {isMobile === true &&
            <List>
                {service.orders.map((order, index) =>
                    <React.Fragment key={index}>
                        <ListItem divider disableGutters>
                            <ListItemSecondaryAction>
                                <IconButton
                                    color="primary"
                                    onClick={(event: any) => {
                                        event.stopPropagation();
                                        service.onSelect({
                                            type: SearchType.Orders,
                                            orderId: order.orderId,
                                            orderNumber: order.orderNumber,
                                            orderDate: order.orderDate,
                                            orderTitle: order.quotes[0]?.title ?? "",
                                            orderType: order.orderType,
                                            articleDescription: '',
                                            articleId: '',
                                            articleModel: '',
                                            articleVersion: '',
                                            workOrderId: 0,
                                            workOrderNumber: ''
                                        });
                                    }}
                                    size="large">
                                    <FaPlus />
                                </IconButton>
                            </ListItemSecondaryAction>
                            <ListItemText>
                                <Grid container spacing={0}>
                                    <Grid item xs={12}>
                                        <Typography variant="body1">
                                            <b>{formatMessage({ id: LocalizationIds.Order })}:</b>
                                        </Typography>
                                        <b>{order.orderType}{order.orderNumber}</b>
                                        <Typography variant="subtitle2">
                                            <Moment date={order.orderDate} format="LL" />
                                        </Typography>
                                        <Typography variant="subtitle2">{order.orderStatus}</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body1">
                                            <b>{formatMessage({ id: LocalizationIds.Customer })}:</b>
                                        </Typography>
                                        <Typography>{order.customerName}</Typography>
                                        <Typography variant="subtitle2">{order.customerCountry}</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body1">
                                            <b>{formatMessage({ id: LocalizationIds.Quote })}:</b>
                                        </Typography>
                                        {order.quotes &&
                                            order.quotes.map(quote =>
                                                <Fragment key={quote.quoteId}>
                                                    <Typography>{formatMessage({ id: LocalizationIds.Quote })}&nbsp;{quote.quoteNumber}&nbsp;{formatMessage({ id: LocalizationIds.Rev })}&nbsp;{quote.quoteRevision}&nbsp;&middot;&nbsp;{quote.title}</Typography>
                                                </Fragment>
                                            )}
                                        {order.layoutNumber?.trim() !== '' &&
                                            <>{formatMessage({ id: LocalizationIds.Layout })}:&nbsp;{order.layoutNumber?.trim()}</>
                                        }
                                    </Grid>

                                </Grid>
                            </ListItemText>
                        </ListItem>
                    </React.Fragment>
                )}
            </List>
        }
    </>;
}

export default OrderResults;